// import logo from "./logo.svg";
import "./style/App.css";
import { Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import About from "./Pages/About/About";
// import Navbar from "./Hooks/Navbar/Navbar";
import Home from "./Pages/Home/Home";
import Portfolio from "./Pages/Portfolio/Portfolio";
import Resume from "./Pages/Resume/Resume";
import Services from "./Pages/Services/Services";
import Contact from "./Pages/Contact/Contact";
import { AnimatePresence } from "framer-motion";
import NavbarForMobile from "./Hooks/NavbarForMobile/NavbarForMobile";
import ReactGA from "react-ga4";
import { useEffect, useCallback } from "react";
import { Analytics } from "@vercel/analytics/react";
import { Helmet } from "react-helmet";
// import Slider from "./Hooks/Slider/Slider";
function App() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const utm_source = searchParams.get("utm_source");
  // console.log(utm_source);

  const sendUtmSource = useCallback(async () => {
    if (!utm_source) {
      // console.log("utm_source is not defined");

      return;
    }
    try {
      const res = await fetch("https://www.rexa4.com/api/sendEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subject: "visit to portfolio",
          message: `this messege about a visit to portfolio source is ${utm_source}`,
          reciver: "mohammad_khattab@rexa4.com",
        }),
      });

      const data = await res.json();

      if (res.ok) {
        console.log("Message sent successfully:", data);
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  }, [utm_source]);
  useEffect(() => {
    sendUtmSource();
  }, [sendUtmSource]);

  // "homepage": "https://Nour99988.github.io/myportfolio",

  useEffect(() => {
    ReactGA.initialize([
      {
        trackingId: "G-NPG63PYEB2",
      },
    ]);
    // ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: document.location.pathname });
  }, [location]);
  return (
    <>
      <Helmet>
        <title>Mohammad Nour Khattab - Full Stack Developer</title>
        <meta
          name="description"
          content="Experienced Full Stack Developer with over 5 years of expertise in web and mobile application development. Specializing in modern web technologies and innovative solutions."
        />
        <meta
          name="keywords"
          content="Full Stack Developer, Web Developer, Mobile Developer, React, JavaScript, Node.js, Mohammad Nour Khattab, Frontend Developer, Backend Developer"
        />

        {/* Social Media Meta Tags */}
        <meta property="og:title" content="Mohammad Nour Khattab - Full Stack Developer Portfolio" />
        <meta
          property="og:description"
          content="Full Stack Developer with 5+ years of experience in web and mobile development"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://nour-it.dev" />
        <meta property="og:image" content="https://nour-it.dev/img/bg.png" />

        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="Mohammad Nour Khattab" />
        <link rel="canonical" href="https://nour-it.dev" />
      </Helmet>
      <div className="App">
        <div className="background">
          <img src="./img/bg1.jpg" alt="cover" />
        </div>

        <AnimatePresence exitBeforeEnter>
          <NavbarForMobile />
          <Routes location={location} key={location.key}>
            <Route path="/" element={<Home />} />
            {/* <Route path="/test" element={<Slider />} /> */}
            <Route path="/About" element={<About />} />
            <Route path="/Portfolio" element={<Portfolio />} />
            <Route path="/Resume" element={<Resume />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/Contact" element={<Contact />} />
          </Routes>
        </AnimatePresence>
        <Analytics />
      </div>
    </>
  );
}

export default App;
